<app-news 
[showMap]="false"
[showRelated]="false"
[showViews]="false"
[preload]="true"
[topic]="topic"
[images]="images"
[detail]="detail"
[loading]="false"></app-news>

